import React, { useContext } from "react";
import classNames from "classnames";
import { Text } from "./base/index";
import { PageStateContext } from "../PageContext";
import { debugLog } from "../utils/index";

const Contact = () => {
  // console.log(" >>>>>> GlobalStateContext");
  // console.log(GlobalStateContext);
  const { pageState } = useContext(PageStateContext);
  // eslint-disable-next-line no-unused-vars
  const { chrome = {}, uiText = {}, contact, formattedDate = "" } = pageState;
  // eslint-disable-next-line no-unused-vars
  const { color = "#000000", logo = "" } = chrome || {};
  const hasContact = contact && contact.length > 0;
  debugLog("contact", contact);
  // return (<div>Contact Not rendering</div>);

  return (
    <div className="h-page mx-page-margin page-break">
      <Text tag="h2" className="mb-10 title-chapter break-after-avoid">
        {uiText.screen_contact}
      </Text>

      <div className="flex flex-wrap mb-10">
        {hasContact &&
          contact.map(
            (
              {
                id,
                title,
                locality,
                email,
                phone,
                internationalPhone,
                addressLine1,
                addressLine2,
              },
              idx
            ) => (
              <div
                key={id}
                className={classNames({
                  "w-1/2 mb-10": true,
                  "pr-5": idx % 2 === 0,
                  "pl-5": idx % 2 === 1,
                })}
              >
                <Text
                  tag="h3"
                  options={{ size: "text-lg" }}
                  className="text-gray mb-1"
                >
                  {title}
                </Text>

                <Text tag="p" className="mb-0 text-gray-3">
                  {addressLine1}
                </Text>

                <Text tag="p" className="mb-0 text-gray-3">
                  {addressLine2}
                </Text>

                <Text tag="p" className="mb-3 text-gray-3">
                  {email}
                </Text>

                <Text tag="label" className="mb-0 text-gray-2">
                  {locality}
                </Text>
                <Text tag="p" className="mb-3 text-gray-3">
                  {phone}
                </Text>

                <Text tag="label" className="mb-0 text-gray-2">
                  {uiText.contact_international}
                </Text>
                <Text tag="p" className="text-gray-3">
                  {internationalPhone}
                </Text>
              </div>
            )
          )}
      </div>
    </div>
  );
};

export default Contact;
